import React from 'react';
import AccountLinks from '../components/AccountLinks';
import News from '../components/News';

const Home = () => {
    return (
        <>
            <AccountLinks />
            {/* <News /> */}
        </>
    );
};

export default Home;
